import { MutationTree } from "vuex";
import {
  ShoppingListFoodList,
  ShoppingListFoodRecommendationsList,
  ShoppingListPantryItemsConsumeFoodList,
  ShoppingListFavoriteFoodList,
  ShoppingListSearchFoodResultList,
  ShoppingListSelectSearchResult,
  ShoppingListState,
  ShoppingListRankingFoodList,
  ShoppingListAppendRegistingListItem,
  ShoppingListSceneCategoryList
} from "@/types/shoppingList";
import { PantryList } from "@/types/pantry";
import NativeClient from "@/client/native-client";

const mutations: MutationTree<ShoppingListState> = {
  updateFoodList: (state, list: ShoppingListFoodList | null) => {
    state.foodList = list;
  },
  updateRecommendationList: (state, list: ShoppingListFoodRecommendationsList | null) => {
    if (list == null) {
      NativeClient.sendDebugLog("Mutations.ts updateRecommendationList clear");
      state.recommendList = null;
    } else {
      state.recommendList = list;
    }
  },
  updateConsumedFoodList: (state, list: ShoppingListPantryItemsConsumeFoodList | null) => {
    if (list == null) {
      NativeClient.sendDebugLog("Mutations.ts updateConsumedFoodList clear");
      state.consumedList = null;
    } else if (state.consumedList == null) {
      NativeClient.sendDebugLog("Mutations.ts updateConsumedFoodList initial");
      state.consumedList = list;
    } else {
      NativeClient.sendDebugLog("Mutations.ts updateConsumedFoodList append");
      const mergedItems = state.consumedList.pantryList.concat(list.pantryList);
      const newList: ShoppingListPantryItemsConsumeFoodList = {
        ...list,
        pantryList: mergedItems
      };
      state.consumedList = newList;
    }
  },
  updateRankingList: (state, list: ShoppingListRankingFoodList | null) => {
    state.rankingList = list;
  },
  updateFavoriteList: (state, list: ShoppingListFavoriteFoodList | null) => {
    if (list == null) {
      NativeClient.sendDebugLog("Mutations.ts updateFavoriteList clear");
      state.favoriteList = null;
    } else if (state.favoriteList == null) {
      NativeClient.sendDebugLog("Mutations.ts updateFavoriteList initial");
      state.favoriteList = list;
    } else {
      NativeClient.sendDebugLog("Mutations.ts updateFavoriteList append");
      const mergedFoods = state.favoriteList.foods.concat(list.foods);
      const newFoodsList: ShoppingListFavoriteFoodList = {
        ...list,
        foods: mergedFoods
      };
      state.favoriteList = newFoodsList;
    }
  },
  clearCategoryList: (state) => {
    NativeClient.sendDebugLog("Mutations.ts clearCategoryList");
  },
  updateSceneCategoryList: (state, list: ShoppingListSceneCategoryList) => {
    NativeClient.sendDebugLog("Mutations.ts updateSceneCategoryList list = " + JSON.stringify(list));
    state.sceneCategoryList = list;
  },
  updateRegistingFoodList: (state, list:  Array<ShoppingListAppendRegistingListItem> | null) => {
    state.registingFoodList = list;
  },
  updateRegistResult: (state, list: ShoppingListFoodList | null) => {
    state.registResultList = list;
  },
  updateSearchResultList: (state, list: ShoppingListSearchFoodResultList | null) => {
    if (list == null) {
      NativeClient.sendDebugLog("Mutations.ts updateSearchIngredientResult clear");
      state.searchResltList = null;
    } else if (state.searchResltList == null) {
      NativeClient.sendDebugLog("Mutations.ts updateSearchIngredientResult initial");
      state.searchResltList = list;
    } else {
      NativeClient.sendDebugLog("Mutations.ts updateSearchIngredientResult append");
      const mergedFoods = state.searchResltList.foods.concat(list.foods);
      const newResult: ShoppingListSearchFoodResultList = {
        ...list,
        foods: mergedFoods
      };
      state.searchResltList = newResult;
    }
  },
  updateSelectCategoryIndex: (state, index: number) => {
    state.previousSelectCategoryIndex = index;
  },
  clearAppendIngredientParameter: (state) => {
    NativeClient.sendDebugLog("mutations clearAppendIngredientParameter");
    state.previousSelectCategoryIndex = 0;
    state.consumedList = null;
    state.rankingList = null;
    state.favoriteList = null;
    state.sceneCategoryList = null;
    state.registingFoodList = null;
  },
  updatePantryList: (state, list: PantryList | null) => {
    state.pantryList = list;
  },
  clearRecommendationFoodList: (state) => {
    state.recommendList = null;
  }
};

export default mutations;
